// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_5e-4";
export var collapsed = "_5e-1";
export var headerBar = "_5e-0";
export var leftHeaderContent = "_5e-3";
export var subjectContainer = "_5e-2";